import type {ComponentProps} from 'react'
import {memo} from 'react'

import {pipelinesApi} from '../../services/pipelinesApi'
import {githubConnectionId} from '../CreatePipelinePage.consts'

import Repositories from './Repositories'

type Props = Pick<ComponentProps<typeof Repositories>, 'onSelect'>

function GitHubRepositoriesContainer(props: Props) {
  const {refetch, groups, isLoadingGroups, isFetching, error} =
    pipelinesApi.endpoints.getGitHubRepositories.useQuery(undefined, {
      selectFromResult: ({data, isLoading, error, isFetching}) => ({
        groups: data,
        isLoadingGroups: isLoading,
        isFetching,
        error,
      }),
    })

  return (
    <Repositories
      {...props}
      groups={groups}
      isLoadingGroups={isLoadingGroups}
      isFetching={isFetching}
      error={error}
      refetch={refetch}
      connectionId={githubConnectionId}
      vcsType={'GitHub'}
    />
  )
}

export default memo(GitHubRepositoriesContainer)
